import { render, staticRenderFns } from "./changeSession.vue?vue&type=template&id=5d25239a"
import script from "./changeSession.vue?vue&type=script&lang=js"
export * from "./changeSession.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports